var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.container,on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{class:this.className}),_vm._v(" "+_vm._s(_vm.$attrs.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }